export const environment = {
  UserGuideUrl:
    'https://elearning.easygenerator.com/bcd568f0-29e3-43fb-a042-238bfbb04e6e/',
  UserGuideSnapshotUrl:
    'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  askMePythonUrl: 'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/',
  baseApiUrl: 'https://de-fidelity-prod.azurewebsites.net/',
  kantarClientID: '8925afc5-e2fe-4877-938b-80d1d57fb8a9',
  kantarApiClientID: '0e5dc8f6-7d8a-4f57-808d-1600a6e5ae12',
  kantarAuthorityID:
    'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  redirectUrl: 'https://fidelitybrandtracking-dataexplorer.kantar.com/landing',
  // redirectUrl: 'https://dev-dataexplorer.kantar.com/landing',  // baseApiUrl: 'https://kapdashboardapidev.azurewebsites.net/',
  logoutURL: 'https://fidelitybrandtracking-dataexplorer.kantar.com/signout-oidc',
  baseUrl: '/',
  sessionTimeOut: 60,
  env: 'dev',
  showUploadModule: true,
  dedicatedCss: false
};
